import { DEPT_WORK_ID, loadOf, sum, type Case, type Staff } from '@kdk/shared';

export type StaffDetailRow = {
  caseId: string;
  /** 案件名。部門業務は '部門業務'、未知の ID は null。 */
  name: string | null;
  dedicated: boolean;
  role: string | null;
  /** 長さ 12。その月に配分がなければ null。 */
  percents: (number | null)[];
};

export type StaffDetail = { rows: StaffDetailRow[]; totals: number[] };

export const buildStaffDetail = (staff: Staff, cases: readonly Case[]): StaffDetail => {
  const byId = new Map(cases.map((c) => [c.id, c]));
  const all = staff.byMonth.flat();
  const ids = [...new Set(all.map((a) => a.caseId))];
  return {
    rows: ids.map((caseId) => {
      const known = byId.get(caseId);
      return {
        caseId,
        name: known?.name ?? (caseId === DEPT_WORK_ID ? '部門業務' : null),
        dedicated: known?.dedicatedAgent ?? false,
        role: all.find((a) => a.caseId === caseId)?.role ?? null,
        percents: staff.byMonth.map((month) => {
          const mine = month.filter((a) => a.caseId === caseId);
          return mine.length === 0 ? null : sum(mine.map((a) => a.percent));
        }),
      };
    }),
    totals: staff.byMonth.map((_, month) => loadOf(staff, month)),
  };
};
